import { iconMap } from '../util';
import { FLOLDER } from '@web-mail/common/constant';
export const folderId2String = (list) => {
    if (Array.isArray(list)) {
        return list.map(id => id && id.toString());
    }
    return list.toString();
};
export const folderId2Number = (list) => {
    let res = list;
    if (Array.isArray(list)) {
        res = list.map(id => {
            try {
                return window === null || window === void 0 ? void 0 : window.parseInt(id);
            }
            catch (e) {
                console.warn('folderId2Number error', e);
            }
            return id;
        });
    }
    else {
        try {
            res = window === null || window === void 0 ? void 0 : window.parseInt(list);
        }
        catch (e) {
            console.warn('folderId2Number error', e);
        }
    }
    return res;
};
export const getForbidMoveFolderIdList = (mailFolderId, isSearching, selectedFolderId, isLocalImport) => {
    const allForbidList = [
        FLOLDER.REDFLAG,
        FLOLDER.DEFAULT,
        FLOLDER.DRAFT,
        FLOLDER.SENT,
        FLOLDER.DELETED,
        FLOLDER.SPAM,
        FLOLDER.ADVITISE,
        FLOLDER.VIRUS,
        FLOLDER.WAITINGISSUE,
        FLOLDER.READYISSUE,
        FLOLDER.TASK,
        FLOLDER.DEFER,
        FLOLDER.UNREAD,
        FLOLDER.STAR,
    ];
    if (folderIdIsContact(mailFolderId)) {
        return allForbidList;
    }
    if (isSearching || selectedFolderId < 0) {
        return allForbidList;
    }
    let filterList = [];
    if (isLocalImport) {
        filterList = [FLOLDER.DEFAULT, FLOLDER.SENT];
    }
    else if (mailFolderId === FLOLDER.DEFAULT) {
        filterList = [FLOLDER.SPAM, FLOLDER.ADVITISE];
    }
    else if ([FLOLDER.SPAM, FLOLDER.ADVITISE].includes(mailFolderId)) {
        filterList = [FLOLDER.DEFAULT];
    }
    else if (mailFolderId === FLOLDER.DELETED) {
        filterList = [FLOLDER.DEFAULT, FLOLDER.SENT, FLOLDER.DRAFT];
    }
    else if (!allForbidList.includes(mailFolderId)) {
        filterList = [FLOLDER.DEFAULT, FLOLDER.SENT, FLOLDER.SPAM, FLOLDER.ADVITISE];
    }
    return [...new Set([...allForbidList.filter(id => !filterList.includes(id)), mailFolderId])];
};
export const folderList2CanMoveTree = (data, forbidIds, className) => {
    var _a, _b;
    const isShow = data.entry.mailBoxId > 0;
    const treeNode = {
        className: className || '',
        key: folderId2String(data.entry.mailBoxId),
        title: data.entry.mailBoxName,
        isLeaf: !((_a = data.children) === null || _a === void 0 ? void 0 : _a.length),
        icon: iconMap.get((_b = data.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId),
        selectable: true,
        style: { display: isShow ? 'flex' : 'none' },
    };
    if (!treeNode.isLeaf && data.children && data.children.length > 0) {
        treeNode.children = data.children.map(node => folderList2CanMoveTree(node, forbidIds, className));
    }
    return treeNode;
};
export const folderList2CanAITidyUpTree = (data, supportIds, className) => {
    var _a, _b;
    let isShow = data.entry.mailBoxId > 0 && (supportIds.includes(data.entry.mailBoxId) || data.entry.mailBoxId >= 100);
    if (data.entry.locked) {
        isShow = false;
    }
    const treeNode = {
        className: className || '',
        key: folderId2String(data.entry.mailBoxId),
        title: data.entry.mailBoxName,
        isLeaf: !((_a = data.children) === null || _a === void 0 ? void 0 : _a.length),
        icon: iconMap.get((_b = data.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId),
        selectable: true,
        style: { display: isShow ? 'flex' : 'none' },
    };
    if (!treeNode.isLeaf && data.children && data.children.length > 0) {
        treeNode.children = data.children.map(node => folderList2CanAITidyUpTree(node, supportIds, className));
    }
    return treeNode;
};
export const folderIdIsVrFolder = (folderId) => {
    if (typeof folderId == 'number') {
        return folderId < 0;
    }
    else if (typeof folderId === 'string' && !folderIdIsContact(folderId)) {
        const id = parseInt(folderId + '');
        return id < 0;
    }
    return false;
};
export const folderIdIsRealFolder = (folderId) => {
    if (typeof folderId == 'number') {
        return folderId >= 0;
    }
    else if (typeof folderId === 'string' && !folderIdIsContact(folderId)) {
        const id = parseInt(folderId + '');
        return id > 0;
    }
    return false;
};
export const isCustomFolder = (folderId) => {
    if (typeof folderId == 'number') {
        return folderId >= 100;
    }
    else if (typeof folderId === 'string' && !folderIdIsContact(folderId)) {
        const id = parseInt(folderId + '');
        return id >= 100;
    }
    return false;
};
export const isSystemFolder = (folderId) => {
    if (typeof folderId == 'number') {
        return folderId < 100;
    }
    else if (typeof folderId === 'string' && !folderIdIsContact(folderId)) {
        const id = parseInt(folderId + '');
        return id < 100;
    }
    return false;
};
export const folderIdIsContact = (id) => {
    if (typeof id == 'number') {
        return false;
    }
    else if (typeof id === 'string' && (id === null || id === void 0 ? void 0 : id.includes('##'))) {
        return true;
    }
    return false;
};
export const createAllFolderId = (folderId, account) => {
    return `global@@${folderId}@@${account}`;
};
export const folderIdIsAllFolderSubAccount = (id) => {
    if (typeof id === 'string' && id.startsWith('global@')) {
        return true;
    }
    return false;
};
const allTopFolderIds = [
    FLOLDER.ALL_RECEIVE,
    FLOLDER.ALL_UNREAD,
    FLOLDER.ALL_SENT,
    FLOLDER.ALL_REDFLAG,
    FLOLDER.ALL_DRAFT,
    FLOLDER.ALL_CUSTOMER_UNFOLLOW,
    FLOLDER.ALL_UNFOLLOW,
    FLOLDER.ALL_EDM_REPLY,
    FLOLDER.ALL_EDM_OTHER_REPLY,
];
export const folderIdIsAllTopFolder = (id) => {
    try {
        if (typeof id === 'number' && allTopFolderIds.includes(id)) {
            return true;
        }
        if (typeof id === 'string') {
            const numberId = parseInt(id);
            if (allTopFolderIds.includes(numberId)) {
                return true;
            }
        }
    }
    catch (error) {
        console.error('Error in folderIdIsAllFolder:', error);
    }
    return false;
};
export const folderIdIsAllFolder = (id) => {
    if (typeof id === 'number' && allTopFolderIds.includes(id)) {
        return true;
    }
    if (typeof id === 'string') {
        try {
            const num = parseInt(id);
            if (allTopFolderIds.includes(num)) {
                return true;
            }
        }
        catch (error) {
            console.error('Error in folderIdIsAllFolder:', error);
        }
        return folderIdIsAllFolderSubAccount(id);
    }
    return false;
};
export const folderIdIsAllUnreadFolder = (id) => {
    if (typeof id === 'number' && id == -42) {
        return true;
    }
    if (typeof id === 'string') {
        try {
            const num = parseInt(id);
            if (num == -42) {
                return true;
            }
            return parseAllFolderSubAccount(id) == -42;
        }
        catch (error) {
        }
    }
    return false;
};
export const folderIdIsAllRedFlagFolder = (id) => {
    if (typeof id === 'number' && id == FLOLDER.ALL_REDFLAG) {
        return true;
    }
    if (typeof id === 'string') {
        try {
            const num = parseInt(id);
            if (num == FLOLDER.ALL_REDFLAG) {
                return true;
            }
            return parseAllFolderSubAccount(id) == FLOLDER.ALL_REDFLAG;
        }
        catch (error) {
        }
    }
    return false;
};
export const folderIdIsAllSentFolder = (id) => {
    if (typeof id === 'number' && id == FLOLDER.ALL_SENT) {
        return true;
    }
    if (typeof id === 'string') {
        try {
            const num = parseInt(id);
            if (num == FLOLDER.ALL_SENT) {
                return true;
            }
            return parseAllFolderSubAccount(id) == FLOLDER.ALL_SENT;
        }
        catch (error) {
        }
    }
    return false;
};
export const folderIdIsAllDraftFolder = (id) => {
    if (typeof id === 'number' && id == FLOLDER.ALL_DRAFT) {
        return true;
    }
    if (typeof id === 'string') {
        try {
            const num = parseInt(id);
            if (num == FLOLDER.ALL_DRAFT) {
                return true;
            }
            return parseAllFolderSubAccount(id) == FLOLDER.ALL_DRAFT;
        }
        catch (error) {
        }
    }
    return false;
};
export const folderIdIsAllReceiveFolder = (id) => {
    if (typeof id === 'number' && id == -41) {
        return true;
    }
    if (typeof id === 'string') {
        try {
            const num = parseInt(id);
            if (num == -41) {
                return true;
            }
            return parseAllFolderSubAccount(id) == -41;
        }
        catch (error) {
        }
    }
    return false;
};
export const folderIdIsAllCustomerUnFollow = (id) => {
    if (typeof id === 'number' && id == FLOLDER.ALL_CUSTOMER_UNFOLLOW) {
        return true;
    }
    if (typeof id === 'string') {
        try {
            const num = parseInt(id);
            if (num == FLOLDER.ALL_CUSTOMER_UNFOLLOW) {
                return true;
            }
            return parseAllFolderSubAccount(id) == FLOLDER.ALL_CUSTOMER_UNFOLLOW;
        }
        catch (error) { }
    }
    return false;
};
export const folderIdIsAllUnFollow = (id) => {
    if (typeof id === 'number' && id == FLOLDER.ALL_UNFOLLOW) {
        return true;
    }
    if (typeof id === 'string') {
        try {
            const num = parseInt(id);
            if (num == FLOLDER.ALL_UNFOLLOW) {
                return true;
            }
            return parseAllFolderSubAccount(id) == FLOLDER.ALL_UNFOLLOW;
        }
        catch (error) { }
    }
    return false;
};
export const folderIdIsAllEdmReply = (id) => {
    if (typeof id === 'number' && id == FLOLDER.ALL_EDM_REPLY) {
        return true;
    }
    if (typeof id === 'string') {
        try {
            const num = parseInt(id);
            if (num == FLOLDER.ALL_EDM_REPLY) {
                return true;
            }
            return parseAllFolderSubAccount(id) == FLOLDER.ALL_EDM_REPLY;
        }
        catch (error) { }
    }
    return false;
};
export const folderIdIsAllEdmOtherReply = (id) => {
    if (typeof id === 'number' && id == FLOLDER.ALL_EDM_OTHER_REPLY) {
        return true;
    }
    if (typeof id === 'string') {
        try {
            const num = parseInt(id);
            if (num == FLOLDER.ALL_EDM_OTHER_REPLY) {
                return true;
            }
            return parseAllFolderSubAccount(id) == FLOLDER.ALL_EDM_OTHER_REPLY;
        }
        catch (error) { }
    }
    return false;
};
export const folderIsUnread = (id) => {
    return id == FLOLDER.UNREAD || folderIdIsAllUnreadFolder(id);
};
export const parseAllFolderSubAccount = (id) => {
    try {
        if (typeof id === 'string' && id.startsWith('global@')) {
            const arr = id.split('@@');
            return parseInt(arr[1]);
        }
        return id + '';
    }
    catch (error) {
        console.error('Error in parseAllFolderSubAccount:', error);
        return id + '';
    }
};
export const parseAccountFromAllFolderSubAccount = (id) => {
    try {
        if (typeof id === 'string' && id.startsWith('global@')) {
            const arr = id.split('@@');
            return arr[2];
        }
    }
    catch (error) {
        console.error('Error in parseAccountFromAllFolderSubAccount:', error);
    }
    return '';
};
export const parseFidFromAllFid = (allfolderId) => {
    const keys = [
        FLOLDER.ALL_RECEIVE,
        FLOLDER.ALL_UNREAD,
        FLOLDER.ALL_SENT,
        FLOLDER.ALL_REDFLAG,
        FLOLDER.ALL_DRAFT,
        FLOLDER.ALL_CUSTOMER_UNFOLLOW,
        FLOLDER.ALL_UNFOLLOW,
        FLOLDER.ALL_EDM_REPLY,
        FLOLDER.ALL_EDM_OTHER_REPLY,
    ];
    const values = [
        FLOLDER.DEFAULT,
        FLOLDER.UNREAD,
        FLOLDER.SENT,
        FLOLDER.REDFLAG,
        FLOLDER.DRAFT,
        FLOLDER.CUSTOMER_UNFOLLOW,
        FLOLDER.UNFOLLOW,
        FLOLDER.EDM_REPLY,
        FLOLDER.EDM_OTHER_REPLY,
    ];
    if (folderIdIsAllTopFolder(allfolderId)) {
        if (keys.includes(+allfolderId)) {
            return values[keys.indexOf(+allfolderId)];
        }
    }
    else if (folderIdIsAllFolder(allfolderId)) {
        const allFid = +parseAllFolderSubAccount(allfolderId);
        if (keys.includes(allFid)) {
            return values[keys.indexOf(allFid)];
        }
    }
    return allfolderId;
};
export const folderIdIsContactGroup = (id) => {
    if (id && folderIdIsContact(id) && id.toString().startsWith('org')) {
        return !0;
    }
    return false;
};
export const isMailFolderId = (id) => {
    if (typeof id == 'number') {
        return true;
    }
    else if (typeof id === 'string' && (id === null || id === void 0 ? void 0 : id.includes('##'))) {
        return false;
    }
    return true;
};
export const folderDisabledShowUnreadId = [FLOLDER.REDFLAG, FLOLDER.DELETED, FLOLDER.SENT];
export const folderCanShowUnread = (fid) => {
    return folderDisabledShowUnreadId.includes(fid);
};
export const isInboxLikeFolder = (id) => {
    const fid = typeof id === 'string' ? parseInt(id, 10) : id;
    return fid !== FLOLDER.SENT && fid !== FLOLDER.ALL_SENT && fid !== FLOLDER.DRAFT && !folderIdIsAllSentFolder(id);
};
export const isFollowFolder = (folderId) => {
    try {
        const fid = parseFidFromAllFid(folderId);
        return [FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW, FLOLDER.ALL_CUSTOMER_UNFOLLOW, FLOLDER.ALL_UNFOLLOW].includes(parseInt(fid + ''));
    }
    catch (e) {
        console.error('[isFollowFolder error]', e);
    }
    return false;
};
export const isAllFollowFolder = (folderId) => {
    try {
        return [FLOLDER.ALL_CUSTOMER_UNFOLLOW, FLOLDER.ALL_UNFOLLOW].includes(parseInt(folderId + ''));
    }
    catch (e) {
        console.error('[isFollowFolder error]', e);
    }
    return false;
};
export const isCustomerUnFollowFolder = (folderId) => {
    try {
        return [FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.ALL_CUSTOMER_UNFOLLOW].includes(parseInt(folderId + ''));
    }
    catch (e) {
        console.error('[isFollowFolder error]', e);
    }
    return false;
};
export const isUnFollowFolder = (folderId) => {
    try {
        const _fid = parseAllFolderSubAccount(folderId);
        return [FLOLDER.UNFOLLOW, FLOLDER.ALL_UNFOLLOW].includes(parseInt(_fid + ''));
    }
    catch (e) {
        console.error('[isFollowFolder error]', e);
    }
    return false;
};
export const getAllAccountsFromTmap = (stateMap) => {
    const accounts = [];
    if (stateMap) {
        for (let i in stateMap) {
            const item = stateMap[i];
            const account = item.accountId;
            if (account) {
                accounts.push(account);
            }
        }
    }
    return accounts;
};
const SKIP_OPEN_NEXT_EXEMPT_FOLDERS = [FLOLDER.SENT, FLOLDER.DRAFT];
export const shouldSkipOpenNext = (folderId) => {
    return !SKIP_OPEN_NEXT_EXEMPT_FOLDERS.includes(folderId);
};
